import config from './package.json';
import { ModuleConfig } from '../../types/configTypes';
import OffersFormContainer from './containers/OffersFormContainer';
import OffersFormReviewContainer from './containers/OffersFormReviewContainer';
import OffersFormSuccessContainer from './containers/OffersFormSuccessContainer';
import offersReducers from './reducers';
import offersSaga from './sagas';
import OffersSmartHomeContainer from './containers/OffersSmartHomeContainer';

export default {
  config,
  routes: {
    '/form': {
      exact: true,
      container: OffersFormContainer,
    },
    '/form/review': {
      exact: true,
      container: OffersFormReviewContainer,
    },
    '/form/success': {
      exact: true,
      container: OffersFormSuccessContainer,
    },
    '/form/:sectionId/:featureId': {
      exact: true,
      container: OffersSmartHomeContainer,
    },
  },
  reducers: {
    offers: {
      reducer: offersReducers,
    },
  },
  sagas: [offersSaga],
} as ModuleConfig;
